import React, { useRef } from 'react';
import { SemanticSearchStoreContext } from './store/SemanticSearchContext';
import { createSemanticSearchStore, SemanticSearchStoreType } from './store/semanticSearchStore';
import { semanticSearchApiService } from './services/semanticSearchApiService';

export const SemanticSearchStoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const storeRef = useRef<SemanticSearchStoreType>();
    if (!storeRef.current) {
        storeRef.current = createSemanticSearchStore({ api: semanticSearchApiService });
    }

    return (
        <SemanticSearchStoreContext.Provider value={storeRef.current}>
            {children}
        </SemanticSearchStoreContext.Provider>
    );
};